module.exports = __webpack_public_path__ + "img/snc-logo.adf723ce.png";